export default {
  // =========================
  // HEADER
  // =========================
  grn_title: "إشعار استلام البضائع (GRN)",
  grn_back: "العودة إلى الطلبات",
  grn_no: "رقم GRN",

  // =========================
  // HEADER DETAILS
  // =========================
  grn_supplier: "المورد",
  grn_received_by: "تم الاستلام بواسطة",
  grn_date: "تاريخ GRN",

  // =========================
  // TABLE
  // =========================
  grn_product: "المنتج",
  grn_uom: "وحدة القياس",
  grn_ordered: "الكمية المطلوبة",
  grn_received: "الكمية المستلمة",
  grn_rejected: "الكمية المرفوضة",
  grn_status: "الحالة",

  // =========================
  // STATUS TEXT
  // =========================
  grn_short: "نقص",
  grn_perfect: "مكتمل",

  // =========================
  // SUMMARY
  // =========================
  grn_summary: "ملخص GRN",
  grn_total_items: "إجمالي العناصر",
  grn_total_ordered: "إجمالي الكمية المطلوبة",
  grn_total_received: "إجمالي الكمية المستلمة",
  grn_total_rejected: "إجمالي الكمية المرفوضة",

  // =========================
  // REMARKS
  // =========================
  grn_remarks: "ملاحظات GRN",
  grn_remarks_placeholder: "أدخل ملاحظات (اختياري)",

  // =========================
  // SIGNATURE
  // =========================
  grn_tap_sign: "اضغط للتوقيع",
  grn_upload_proof: "تحميل الإثبات",
  grn_signature_required: "التوقيع مطلوب قبل تأكيد GRN",

  // =========================
  // ACTIONS
  // =========================
  grn_save: "حفظ كمسودة",
  grn_confirm: "تأكيد GRN",
  grn_download: "تحميل PDF",
  grn_print: "طباعة",

  // =========================
  // SUCCESS / ALERTS
  // =========================
  grn_success: "تم تأكيد GRN — تم تحديث المخزون بنجاح",
  grn_saved: "تم حفظ GRN بنجاح",
  grn_error: "حدث خطأ ما",
  grn_pdf_not_ready: "ملف PDF غير متوفر حالياً",

  // =========================
  // GENERAL (REUSED)
  // =========================
  resview: "عرض",
  resstatus: "الحالة",
  resgoods_receipt_notes: "إشعارات استلام البضائع",

ressearch_grn_order: "ابحث برقم GRN أو رقم الطلب",

resconfirmed_status: "تم التأكيد",
resdraft_status: "مسودة",
respending_status: "قيد الانتظار",
resrejected_status: "مرفوض",

resgrn_no: "رقم GRN",
resorder: "رقم الطلب",

resno_grns_found: "لا توجد إشعارات استلام",

reset: "إعادة تعيين",
};